module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"update_review":"修改评论"}}')
  delete Component.options._Ctor
}
